<script setup lang="ts">
  import type { PhysicalLocation } from '@/entities/Document';
  import PencilIcon from '@/shared/assets/icons/PencilBoldIcon.svg';
  import TrashIcon from '@/shared/assets/icons/TrashBoldIcon.svg';
  import { IconImage } from '@/shared/ui';

  type PhysicalLocationTableRowItem = Pick<PhysicalLocation, 'id' | 'name'>;

  const props = defineProps<{
    item: PhysicalLocationTableRowItem;
  }>();

  const emit = defineEmits<{
    (e: 'edit', id: number): void;
    (e: 'delete', id: number): void;
  }>();

  const handleEdit = () => {
    emit('edit', props.item.id);
  };

  const handleDelete = () => {
    emit('delete', props.item.id);
  };
</script>

<template>
  <tr :data-testid="`physical-location-row-${item.id}`" class="table-row-hover transition-colors">
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ item.name }}
    </td>

    <td class="px-6 py-4.5">
      <div class="flex justify-end items-center gap-1">
        <button
          type="button"
          :data-testid="`physical-location-edit-${item.id}`"
          class="rounded text-gray-xx-02 transition-colors hover:bg-[var(--color-gray-09)]"
          :aria-label="`Editar local ${item.name}`"
          @click.prevent="handleEdit"
        >
          <IconImage :src="PencilIcon" alt="Editar local" class="h-6 w-6" />
        </button>

        <button
          type="button"
          :data-testid="`physical-location-delete-${item.id}`"
          class="rounded text-gray-xx-02 transition-colors hover:bg-[var(--color-gray-09)]"
          :aria-label="`Excluir local ${item.name}`"
          @click.prevent="handleDelete"
        >
          <IconImage :src="TrashIcon" alt="Excluir local" class="h-6 w-6" />
        </button>
      </div>
    </td>
  </tr>
</template>
